import CryptoJS from 'crypto-js';
import httpService from '../../../services/http.service';


export const encryptText = (text, secretKey) => {
    if (!text || !secretKey) {
        return
    }
    const encryptedText = CryptoJS.AES.encrypt(text, secretKey).toString();
    return encryptedText;
};

export const decryptText = (encryptedText, secretKey) => {
    if (!encryptedText || !secretKey) {
        return
    }
    const decryptedText = CryptoJS.AES.decrypt(encryptedText, secretKey).toString(CryptoJS.enc.Utf8);
    return decryptedText;
};

export const parseDecryptedText = (decryptedText) => {
    if(!decryptedText){
        return
    }
    const [userId, licenceNo, startDate, endDate] = decryptedText.split('/');
    return { userId, licenceNo, startDate, endDate };
};


export const cloudLicenceNo = async () => {
    let dataUserPost = { userID: localStorage.getItem("UserId") };
    let LicenceInfo = localStorage.getItem("Licence")
    const Licence = parseDecryptedText(decryptText(LicenceInfo, dataUserPost.userID))
    let license = await httpService.CreateUpdate('getclouduserlicenses', dataUserPost).then(res => res.data)
    if(!license){
        return
    }
    return Licence.licenceNo <= license.UsedProperty
    // return license.UsedProperty <= Licence.license

}
// new design
export const cloudLicenceNoused = async () => {
    let dataUserPost = { userID: localStorage.getItem("UserId") };
    let LicenceInfo = localStorage.getItem("Licence")
    const Licence = parseDecryptedText(decryptText(LicenceInfo, dataUserPost.userID))

    let license = await httpService.CreateUpdate('getclouduserlicenses', dataUserPost).then(res => res.data)

    console.log(license, "asdfghjkl", Licence)

    const endDate = new Date(Licence.endDate);
    const currentDate = new Date();
    const differenceInMilliseconds = endDate.getTime() - currentDate.getTime();
    const differenceInDays = Math.ceil(differenceInMilliseconds / (1000 * 3600 * 24));

    let backgroundColor = '';

    if (differenceInDays <= 7) {
        backgroundColor = '#f3cbbd'; // 0 to 7 days: Red color
    } else if (differenceInDays <= 30) {
        backgroundColor = '#fff6b4'; // 8 to 30 days: Yellow color
    } else if (differenceInDays <= 60) {
        backgroundColor = '#e7feff '; // 30 to 60 days: Blue color
    }
    return { "licenceNo": Licence.licenceNo, "UsedProperty": license.UsedProperty, "backgroundColor": backgroundColor, "endDate": Licence.endDate }
    // return license.UsedProperty <= Licence.license

}
// -----

const userLicenceInfo = (userId, license, startDate, endDate) => {
    return `${userId}/${license}/${startDate}/${endDate}`;
};


export const cloudLicenceExpire = async () => {
    try {
        const dataUserPost = {
            userID: localStorage.getItem("customerId"),
            userID1: localStorage.getItem("UserId"),
        };



        const license = await httpService
            .CreateUpdate('getclouduserlicensesinfo', dataUserPost)
            .then((res) => res.data);

        console.log(license, "license")
        const UserId = { userID: localStorage.getItem("UserId") };

        let LicenceInfo = localStorage.getItem("Licence");
        const Licence = parseDecryptedText(decryptText(LicenceInfo, UserId?.userID));

        localStorage.setItem(
            "Licence",
            encryptText(
                userLicenceInfo(
                    license.data._id,
                    license.data.licenceNo,
                    license.data.startDate,
                    license.data.endDate
                ),
                license.data._id
            )
        );

        console.log(license, "license", Licence, " / ", Licence.startDate, "?", Licence.endDate);
        console.log("aaaaaaaa", license.data._id, license.data.licenceNo, license.data.startDate, license.data.endDate);

        const startDate = new Date(`${Licence.startDate}T00:00:00.000Z`);
        let currentDate = new Date(license.data.CurrentDate);
        const endDate = new Date(`${Licence.endDate}T00:00:00.000Z`);

        // Set hours, minutes, seconds, and milliseconds to zero
        startDate.setHours(0, 0, 0, 0);
        currentDate.setHours(0, 0, 0, 0);
        endDate.setHours(0, 0, 0, 0);

        console.log(currentDate, "currentDate2", startDate);

        return startDate <= currentDate && currentDate <= endDate;
    } catch (error) {
        console.error("Error checking license status:", error);
        console.log("license", "license")

        // Handle the error appropriately (e.g., return false or throw an error)
        return false;
    }
};

// export const cloudLicenceExpire = async () => {
//     let dataUserPost = { userID: localStorage.getItem("customerId"),userID1: localStorage.getItem("UserId")  };
//     let UserId = { userID: localStorage.getItem("UserId") };

//     let LicenceInfo = localStorage.getItem("Licence");
//     const Licence = parseDecryptedText(decryptText(LicenceInfo, UserId.userID));
//     let license = await httpService.CreateUpdate('getclouduserlicensesinfo', dataUserPost).then(res => res.data);
//     localStorage.setItem("Licence",encryptText(userLicenceInfo(license.data._id,license.data.licenceNo,license.data.startDate,license.data.endDate),license.data._id) );


//     console.log(license, "license", Licence, " / ", Licence.startDate, "?", Licence.endDate);
//     console.log("aaaaaaaa",license.data._id,license.data.licenceNo,license.data.startDate,license.data.endDate)

//     const startDate = new Date(`${Licence.startDate}T00:00:00.000Z`);
//     let currentDate = new Date(license.data.CurrentDate);
//     const endDate = new Date(`${Licence.endDate}T00:00:00.000Z`);

//     // Set hours, minutes, seconds, and milliseconds to zero
//     startDate.setHours(0, 0, 0, 0);
//     currentDate.setHours(0, 0, 0, 0);
//     endDate.setHours(0, 0, 0, 0);

//     console.log(currentDate, "currentDate2", startDate);

//     return startDate <= currentDate && currentDate <= endDate;
// };



// export const cloudLicenceExpire = async () => {
//     let dataUserPost = { userID: localStorage.getItem("UserId") };
//     let LicenceInfo = localStorage.getItem("Licence")
//     const Licence = parseDecryptedText(decryptText(LicenceInfo, dataUserPost.userID))
//     let license = await httpService.CreateUpdate('getclouduserlicenses', dataUserPost).then(res => res.data)


//     console.log(license,"license",Licence," / ",Licence.startDate,"?",Licence.endDate)
//     // return Licence.license<=license.UsedProperty
//     // const startDate = new Date(Licence.startDate+"T00:00:00:000Z")
//     const startDate = new Date(Licence.startDate + "T00:00:00.000Z");
//     let currentDate = new Date(license.CurrentDate);
//     const endDate = new Date(Licence.endDate);
//     //  currentDate = currentDate.toISOString().split('T')[0];

//     console.log(currentDate,"currentDate2", startDate)
//     // const timeDiff = endDate - currentDate;
//     // const daysRemaining = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));

//     // return currentDate <= endDate
//     console.log(startDate,"license",endDate,currentDate,"   ",startDate <= currentDate,currentDate <= endDate)


//     // return  endDate<= currentDate<startDate
//     return (startDate <= currentDate && currentDate <= endDate)



// }


// export const Checkkeylok_validation = async (x) => {
//     let res = await httpService.get("checkkeylok").then((res) => res.data)
//       .catch((err) => {
//         setErrorMessage("Can not validate Licence File due to bad network");
//         // setErrorPage(true);
//         localStorage.removeItem("Username");
//         sessionStorage.removeItem("session");
//       });
//     if (res === undefined || res === null) return;
//     setLicense(res.output);
//     if (res && res.output && res.output.tokenErr && res.output.tokenErr === 'TokenNotFound') {
//       // user type normal or clouduser
//       if (localStorage.getItem('UserType') == 'clouduser')
//         setVerifyTokenUser(false)
//       else
//         setVerifyToken(false)
//       localStorage.clear();
//     }
//     if (res.output.NumberOfLicence === '' || res.output.NumberOfLicence === '0' || res.output.isValidLicence === false) {
//       if (res.output.msg === "LicenseNotFound") {
//         setErrorMessage("License file not found on the server.");
//         localStorage.removeItem("Username");
//         sessionStorage.removeItem("session");
//         // setErrorPage(true);
//       } else if (res.output.msg === "licenseExpire") {
//         setErrorMessage("License Expired, Please contact your vendor to renew it.");
//         localStorage.removeItem("Username");
//         sessionStorage.removeItem("session");
//         // setErrorPage(true);
//       } else if (res.output.msg === "invalidMacAddress") {
//         setErrorMessage("Your MacAddress/Machine ID not match with license file, Please contact your vendor.");
//         localStorage.removeItem("Username");
//         sessionStorage.removeItem("session");
//         // setErrorPage(true);
//       }
//     } else {
//       if (res.output.DueDate && res.output.DueDate != (new Date()).getDate().toString()) {
//         setErrorMessage("License Expired, Please contact your vendor to renew it.");
//         localStorage.removeItem("Username");
//         sessionStorage.removeItem("session");
//         // setErrorPage(true);
//       }
//       else if (res.output.DueDate && x % 30 === 0) {
//         if (localStorage.getItem("isSession") == 'true')
//         window.confirm('Your license limit does not allow for more properties. please contact your vender to delete some properties.')
//         // setErrorPage(false);
//       }
//       else {
//         // setErrorPage(false);
//       }
//     }
//     return ++x % 30;
//   };

